import React from 'react'
import styled from 'styled-components'
import { userInfoProps } from '../../../constants/usercenter'

const BannerWrapper = styled.div`
  width: 100%;
  margin-top: -70px;
  position: relative;
  ${({ theme }) => theme.mediaWidth.upToMedium`
    padding-top: 70px;
  `};
`
const BannerPic = styled.img`
  cursor: pointer;
  width: 100%;
  position: relative;
  max-height: 400px;
`

const AvatarWrapper = styled.div`
  margin: auto;
  margin-top: -101px;
  max-width: 1224px;
  position: relative;
  ${({ theme }) => theme.mediaWidth.upToMedium`
    margin-top: -50px;
  `};
`

const Avatar = styled.img`
  cursor: pointer;
  width: 202px;
  height: 202px;
  border-radius: 100%;
  ${({ theme }) => theme.mediaWidth.upToMedium`
    width: 102px;
    height: 102px;
  `};
`

export default function Banner({info}: {info: userInfoProps} ) {
  return (
    <BannerWrapper>
      <BannerPic src={info.banner ? info.banner : 'https://d3ggs2vjn5heyw.cloudfront.net/static/nfts/artworks/0aefa6d04b3a457f8a9e637c51715015.jpg'}/>
          <AvatarWrapper>
            <Avatar src={info.avatar ? info.avatar : 'https://d3ggs2vjn5heyw.cloudfront.net/static/nfts/artworks/271129eb168e43aba962134e6989f0d7.jpg'}/>
          </AvatarWrapper>
    </BannerWrapper>
  )
}
